module.exports = __webpack_public_path__ + "static/media/pic24@3x.c6363b5c.png";